import "./daterangepicker.css"
import "./daterangepicker-custom.css"
import DateRangePicker from "./daterangepicker.js"

export default DateRangePicker
